exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.optionsHolder[data-v-330dad40] {\n  position: absolute;\n  background: #FFF;\n  top: 100%;\n  left: 0;\n  z-index: 5;\n  width: 150px;\n  margin-top: 0.2rem;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-330dad40","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/tools/reservation/changeStatusBtn.vue
// module id = 1724
// module chunks = 0